import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function generatePDF(
  contentId: string,
  excludeIds: string[],
  name: string
): Promise<void> {
  const input: HTMLElement | null = document.getElementById(contentId);
  const margin = 10;

  if (!input) {
    throw new Error(`Element with id '${contentId}' not found.`);
  }

  try {
    const excludedElements: HTMLElement[] = [];
    excludeIds.forEach((id) => {
      const excludedElement = document.getElementById(id);
      if (excludedElement) {
        excludedElement.style.display = "none";
        excludedElements.push(excludedElement);
      }
    });

    const canvas = await html2canvas(input);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    const imgWidth = pdf.internal.pageSize.getWidth() - margin * 2;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);
    heightLeft -= pdf.internal.pageSize.getHeight() - margin * 2;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(
        imgData,
        "PNG",
        margin,
        position + margin,
        imgWidth,
        imgHeight
      );
      heightLeft -= pdf.internal.pageSize.getHeight() - margin * 2;
    }

    excludedElements.forEach((element) => {
      element.style.display = "";
    });

    pdf.save(name + ".pdf");
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw new Error("Error generating PDF");
  }
}
